module.exports = __webpack_public_path__ + "default-db.png?4a2840cfa0bafc3bb371d3a25f356d38";